<template>
  <!-- INFORMAÇÕES RELACIONADAS A TABELA -->
  <div class='rf-tabela-filtro-tela' v-if="status === '' && Object.keys(cpntField).length >= 1">
    <template v-if='cpntStatus !== ""'>
      <RF-Status :cpntStatus='cpntStatus' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else-if='cpntStatus === ""'>
      <template v-for="(filtro, indexF) in cpntField">
        <template v-if="filtro.hasOwnProperty('id') && filtro.id !== ''">
          <RF-Select2 :key="indexF" v-if='filtro.tipo === "select2"' 
            :data-time="time"
            :class="'rf-filtro-tela-' + indexF"

            :cpntStatus='filtro.status'
            :cpntId='filtro.id'
            :cpntClassDivField='filtro.classDivField'
            :cpntNome='filtro.nome'
            :cpntValue='filtro.value'
            :cpntOptions='filtro.options'
            :cpntKeyValue='filtro.keyValue'
            :cpntKeyMostra='filtro.keyMostra'
            :cpntAutoComplete='filtro.autocomplete'
            :cpntDisabled='filtro.disabled'
            :cpntMostrar='filtro.mostrar'
            :cpntSearchMinimo='filtro.searchMinimo'
            :cpntMensagem='filtro.mensagem'
            :cpntOptionInicialNome='filtro.optionInicialNome'
            :cpntOptionInicialValue='filtro.optionInicialValue'
            :cpntMensagemTipo='filtro.mensagemTipo'
            :cpntAddOption='filtro.addOption'
            :cpntMultiple='filtro.multiple'
            :cpntExplica='filtro.explica'

            :cpntOnChange='filtro.onChange'
          ></RF-Select2>

          <RF-Select2-Chosen :key="indexF" v-if='filtro.tipo === "select2-chosen"' 
            :data-time="time"
            :class="'rf-filtro-tela-' + indexF"

            :cpntStatus='filtro.status'
            :cpntId='filtro.id'
            :cpntClassDivField='filtro.classDivField'
            :cpntNome='filtro.nome'
            :cpntValue='filtro.value'
            :cpntOptions='filtro.options'
            :cpntKeyValue='filtro.keyValue'
            :cpntKeyMostra='filtro.keyMostra'
            :cpntAutoComplete='filtro.autocomplete'
            :cpntDisabled='filtro.disabled'
            :cpntMostrar='filtro.mostrar'
            :cpntMensagem='filtro.mensagem'
            :cpntOptionInicialNome='filtro.optionInicialNome'
            :cpntOptionInicialValue='filtro.optionInicialValue'
            :cpntMensagemTipo='filtro.mensagemTipo'
            :cpntAddOption='filtro.addOption'
            :cpntMultiple='filtro.multiple'
            :cpntExplica='filtro.explica'
            :cpntAllRegistro='filtro.allRegistro'

            :cpntOnChange='filtro.onChange'
          ></RF-Select2-Chosen>

          <RF-Input :key="indexF" v-else-if='filtro.tipo === "input"'
            :data-time="time"
            :class="'rf-filtro-tela-' + indexF"

            :cpntStatus='filtro.status'
            :cpntId='filtro.id'
            :cpntTabIndex='filtro.tabIndex'
            :cpntClassDivField='filtro.classDivField'
            :cpntNome='filtro.nome'
            :cpntValue='filtro.value'
            :cpntType='filtro.type'
            :cpntAutoComplete='filtro.autocomplete'
            :cpntMask='filtro.mask'
            :cpntDisabled='filtro.disabled'
            :cpntMostrar='filtro.mostrar'
            :cpntAutoFocus='filtro.autofocus'
            :cpntMensagem='filtro.mensagem'
            :cpntMensagemTipo='filtro.mensagemTipo'
            :cpntPlaceholder='filtro.placeholder'
            :cpntExplica='filtro.explica'
            :cpntMaxLength='filtro.maxLength'

            :cpntOnChange='filtro.onChange'
            :cpntOnBlur='filtro.onBlur'
            :cpntOnKeyPressEnter='filtro.onKeyPressEnter'
            :ref='filtro.tipo'
          ></RF-Input>

          <div :key="indexF" v-else-if='filtro.tipo === "checkbox"' :class="'rf-filtro-checkbox rf-filtro-tela-' + indexF">
            <RF-Checkbox-Tabela
              style='position: relative; top: -1px;'
              :data-time2='cpntTime' 
              :data-time='time' 

              :cpntStatus='filtro.status'
              :cpntId='filtro.id' 
              :cpntNome='filtro.nome'
              :cpntValue='filtro.value'
              :cpntChecked='filtro.checked'
              :cpntExplica='filtro.explica'

              :cpntOnChange='filtro.onChange'
            ></RF-Checkbox-Tabela>
          </div>

          <div :key="indexF" v-else-if='filtro.tipo === "input-busca"' :class="'rf-filtro-tela-' + indexF">
            <div class="input-group">
              <input 
                :data-time='time'

                ref='input-busca' 
                class="form-control" 
                type="text" 
                :placeholder="filtro.placeholder" 
                @keyup.enter='filtrosRealizarBusca' 
                v-model='filtro.value'>
              <span class="input-group-addon" style="cursor: pointer;" @click='filtrosRealizarBusca'><i class="fa fa-search"></i></span>
            </div>
          </div>
          <div :key="indexF" v-else-if='filtro.tipo === "data" && filtroExtras.hasOwnProperty("status") && filtroExtras.status === ""' :class="'rf-filtro-tela-' + indexF" :style="filtroExtras.field.dataTipo.value !== '7' ? 'max-width: 175px' : 'max-width: 370px'" v-show="cpntField[filtroExtras.ref].mostrar">
            <table>
              <tr>
                <td colspan="3" :style="filtroExtras.field.dataTipo.value !== '7' ? 'max-width: 175px' : 'max-width: 370px'">
                  <RF-Select2
                    :data-time="time"

                    :cpntStatus='filtroExtras.field.dataTipo.status'
                    :cpntId='filtroExtras.field.dataTipo.id'
                    :cpntClassDivField='filtroExtras.field.dataTipo.classDivField'
                    :cpntNome='filtroExtras.field.dataTipo.nome'
                    :cpntValue='filtroExtras.field.dataTipo.value'
                    :cpntOptions='filtroExtras.field.dataTipo.options'
                    :cpntKeyValue='filtroExtras.field.dataTipo.keyValue'
                    :cpntKeyMostra='filtroExtras.field.dataTipo.keyMostra'
                    :cpntAutoComplete='filtroExtras.field.dataTipo.autocomplete'
                    :cpntDisabled='filtroExtras.field.dataTipo.disabled'
                    :cpntMostrar='filtroExtras.field.dataTipo.mostrar'
                    :cpntMensagem='filtroExtras.field.dataTipo.mensagem'
                    :cpntOptionInicialNome='filtroExtras.field.dataTipo.optionInicialNome'
                    :cpntOptionInicialValue='filtroExtras.field.dataTipo.optionInicialValue'
                    :cpntMensagemTipo='filtroExtras.field.dataTipo.mensagemTipo'
                    :cpntAddOption='filtroExtras.field.dataTipo.addOption'
                    :cpntMultiple='filtroExtras.field.dataTipo.multiple'
                    :cpntExplica='filtroExtras.field.dataTipo.explica'

                    :cpntOnChange='filtroExtras.field.dataTipo.onChange'
                  ></RF-Select2>
                </td>

                <template v-if="filtroExtras.field.dataTipo.value === '7'">
                  <td class="separador">&nbsp;&nbsp;</td>
                  <td>
                    <!-- <div style="padding-left: 0px; padding-bottom: 5px;">De</div> -->
                    <RF-Input-Calendario
                      :data-time="time"

                      :cpntStatus='filtroExtras.field.dataIni.status'
                      :cpntId='filtroExtras.field.dataIni.id'
                      :cpntClassDivField='filtroExtras.field.dataIni.classDivField'
                      :cpntNome='filtroExtras.field.dataIni.nome'
                      :cpntValue='filtroExtras.field.dataIni.value'
                      :cpntAutoComplete='filtroExtras.field.dataIni.autocomplete'
                      :cpntMask='filtroExtras.field.dataIni.mask'
                      :cpntDisabled='filtroExtras.field.dataIni.disabled'
                      :cpntMostrar='filtroExtras.field.dataIni.mostrar'
                      :cpntAutoFocus='filtroExtras.field.dataIni.autofocus'
                      :cpntMensagem='filtroExtras.field.dataIni.mensagem'
                      :cpntMensagemTipo='filtroExtras.field.dataIni.mensagemTipo'
                      :cpntPlaceholder='filtroExtras.field.dataIni.placeholder'
                      :cpntExplica='filtroExtras.field.dataIni.explica'
                      :cpntConfig='filtroExtras.field.dataIni.config'
                      :cpntTabIndex='filtroExtras.field.dataIni.tabIndex'

                      :cpntOnChange='filtroExtras.field.dataIni.onChange'
                      :ref='filtroExtras.field.dataIni.tipo'
                    ></RF-Input-Calendario>
                  </td>
                  <td class="separador">&nbsp;&nbsp;</td>
                  <td>
                    <!-- <div style="padding-left: 0px; padding-bottom: 5px;">Até</div> -->
                    <RF-Input-Calendario
                      :data-time="time"

                      :cpntStatus='filtroExtras.field.dataFim.status'
                      :cpntId='filtroExtras.field.dataFim.id'
                      :cpntClassDivField='filtroExtras.field.dataFim.classDivField'
                      :cpntNome='filtroExtras.field.dataFim.nome'
                      :cpntValue='filtroExtras.field.dataFim.value'
                      :cpntAutoComplete='filtroExtras.field.dataFim.autocomplete'
                      :cpntMask='filtroExtras.field.dataFim.mask'
                      :cpntDisabled='filtroExtras.field.dataFim.disabled'
                      :cpntMostrar='filtroExtras.field.dataFim.mostrar'
                      :cpntAutoFocus='filtroExtras.field.dataFim.autofocus'
                      :cpntMensagem='filtroExtras.field.dataFim.mensagem'
                      :cpntMensagemTipo='filtroExtras.field.dataFim.mensagemTipo'
                      :cpntPlaceholder='filtroExtras.field.dataFim.placeholder'
                      :cpntExplica='filtroExtras.field.dataFim.explica'
                      :cpntConfig='filtroExtras.field.dataFim.config'
                      :cpntTabIndex='filtroExtras.field.dataFim.tabIndex'

                      :cpntOnChange='filtroExtras.field.dataFim.onChange'
                      :ref='filtroExtras.field.dataFim.tipo'
                    ></RF-Input-Calendario>
                  </td>
                </template>  
              </tr>
            </table>
          </div>
        </template>
      </template>
    </template>
  </div>
</template>

<style>
  .rf-tabela-filtro-tela {
    float: right;
    width: calc(100% - 150px);
    text-align: right;
  }
  /* CONFIGURAÇÕES DOS FILTROS DAS TELAS */
  /* --------------------------------------------------------------------------------------------- */
  .rf-tabela-filtro-tela > div {
    margin: 20px 5px 0px 5px !important;
  }
  /* .rf-tabela-filtro-tela > div:last-child {
    margin: 5px 0px 0px 0px;
  } */
  .rf-tabela-filtro-tela > .rf-filtro-tela-data {
    margin: 2px 5px 0px 5px !important;
    text-align: right;
  }
  .rf-tabela-filtro-tela > :not(.input-group) {
    display: inline-block;
    vertical-align: middle;
  }

  .rf-tabela-filtro-tela > .rf-input-group,
  .rf-tabela-filtro-tela > .rf-input-group > div,
  .rf-tabela-filtro-tela > .rf-input-group > div > div > div,
  .rf-tabela-filtro-tela > div > div > div.rf-field-select2,
  .rf-tabela-filtro-tela > .rf-filtro-tela-data > table > tr > td > div.rf-input-group {
    margin-bottom: 0px !important;
  }
    .rf-tabela-filtro-tela > div.rf-field-select2,
    .rf-tabela-filtro-tela > .rf-input-group > div > button,
    .rf-tabela-filtro-tela > div > div > div.rf-field-select2,
    .rf-tabela-filtro-tela > .rf-input-group > div > div > div > div > span.select2,
    .rf-tabela-filtro-tela > .rf-filtro-tela-data > table > tr > td > div.rf-field-select2 {
      vertical-align: middle;
    }

    .rf-tabela-filtro-tela > div.rf-field-select2 > div > .select2-container > span > span,
    .rf-tabela-filtro-tela > .rf-input-group > div > button,
    /* .rf-tabela-filtro-tela > .rf-input-group > div > div > div > div > .select2-container > span > span, */
    .rf-tabela-filtro-tela > .rf-filtro-tela-data > table > tr > td > div.rf-field-select2 > div > .select2-container > span > span {
      height: 34px;
    }
    .rf-tabela-filtro-tela > div.rf-field-select2 > div > .select2-container > span > span,
    .rf-tabela-filtro-tela > .rf-input-group > div > button,
    .rf-tabela-filtro-tela > .rf-input-group > div > div > div > div > .select2-container > span > span,
    .rf-tabela-filtro-tela > div > div > div.rf-field-select2 > div > .select2-container > span > span,
    .rf-tabela-filtro-tela > .rf-filtro-tela-data > table > tr > td > div.rf-field-select2 > div > .select2-container > span > span {
      border: 1px solid #2e6da4 !important;
      text-align: center;
    }

      .rf-tabela-filtro-tela > div.rf-field-select2 > div > .select2-container > span > span > span,
      .rf-tabela-filtro-tela > div > div > div.rf-field-select2 > div > .select2-container > span > span > span,
      .rf-tabela-filtro-tela > .rf-filtro-tela-data > table > tr > td > div.rf-field-select2 > div > .select2-container > span > span > span {
        height: 34px;
        line-height: 34px;
      }

  .rf-tabela-filtro-tela > .rf-filtro-checkbox {
    width: 30px;
    vertical-align: -10px;
    margin: 18px 5px 0px 5px;
  }
  .rf-tabela-filtro-tela > .rf-filtro-checkbox > span > label:before {
    border: 1px solid #2e6da4 !important;
    width: 26px !important;
    height: 26px !important;
    line-height: 24px !important;
  }

  .rf-tabela-filtro-tela > div > div > input.form-control,
  .rf-tabela-filtro-tela > .rf-filtro-tela-data > table > tr > td > div.rf-input-group > input,
  .rf-tabela-filtro-tela > .rf-filtro-tela-data > table > tr:not(:first-child) > td > div > input {
    border: 1px solid #2e6da4;
  }
  .rf-tabela-filtro-tela > .rf-filtro-tela-data > table > tr:not(:first-child) > td > div > input {
    text-align: center;
  }
  .rf-tabela-filtro-tela > div > div > input.form-control ~ .input-group-addon {
    background: #337ab7;
    border: 1px solid #2e6da4;
    cursor: pointer;
  }
    /* .rf-tabela-filtro-tela > .rf-filtro-tela-data > table > tr > td > div.rf-input-group > input {
      border-bottom: none;
    } */
    .rf-tabela-filtro-tela > div > div > input.form-control ~ .input-group-addon > svg {
      color: #fff;
    }

  .rf-tabela-filtro-tela > .rf-filtro-tela-busca {
    max-width: 250px;
  }
  .rf-tabela-filtro-tela > .rf-filtro-tela-data > table {
    width: 100%;
  }
    .rf-tabela-filtro-tela > .rf-filtro-tela-data > table > tr > td > div.rf-field-select2 {
      width: 175px;
      max-width: 175px;
    }
    .rf-tabela-filtro-tela > .rf-filtro-tela-data > table > tr > td:not(:first-child):not(.separador) {
      padding-top: 5px;
      width: 40%;
      min-width: 115px;
    }
    .rf-tabela-filtro-tela > .rf-filtro-tela-data > table > tr > td:first-child:not(.separador) > div {
      margin-top: 0px;
    }
    .rf-tabela-filtro-tela > .rf-filtro-tela-data > table > tr > td:not(:first-child):not(.separador) > div {
      margin-top: -5px;
    }
    .rf-tabela-filtro-tela > .rf-filtro-tela-data > table > tr > td.separador {
      width: 2%;
      min-width: 10px;
    }
      .rf-tabela-filtro-tela > .rf-filtro-tela-data > table > tr > td:not(:first-child) > div.rf-input-group {
        width: 90px;
        /* width: 100%; */
      }
</style>

<script>
  export default {
    name: 'RF-Filtro-Busca-Telas',
    components: {
      'RF-Input': () => import('@/components/rf-geral/input/RF-Input.vue'),
      'RF-Select2': () => import('@/components/rf-geral/select2/RF-Select2.vue'),
      'RF-Select2-Chosen': () => import('@/components/rf-geral/select2-chosen/RF-Select2-Chosen.vue'),
      'RF-Input-Calendario': () => import('@/components/rf-geral/input-calendario/RF-Input-Calendario.vue'),
      'RF-Checkbox-Tabela': () => import('@/components/rf-geral/checkbox/RF-Checkbox-Tabela.vue')
    },
    props: {
      cpntTime: {
        required: true,
        type: [ String, Number ]
      },
      cpntStatus: {
        required: true
      },
      cpntField: {
        required: true,
        type: Object
      },

      cpntOnRealizaBusca: {
        required: true
      }
    },
    data: function () {
      return {
        status: null,
        time: '',
        filtroExtras: {}
      }
    },
    mounted: function () {
      this.filtrosIniciar()
    },
    methods: {
      filtrosIniciar: function () {
        var self = this

        var moment = require('moment')

        // SETA O STATUS DA TELA
        self.status = 'carregando'

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // INICIA A VARIAVEL QUE VAI RECEBER A KEY DO CAMPO DATA
        var keyFiltroData = null

        for (var key in self.cpntField) {
          if (!self.cpntField[key].hasOwnProperty('id')) {
            self.cpntField[key].id = ('rf-filtro-busca-' + Math.floor(Math.random() * (9999 - 1000)) + 1000)
          }

          if (self.cpntField[key].tipo === 'data') {
            keyFiltroData = key
          }
        }

        if (keyFiltroData !== null) {
          self.filtroExtras = {
            status: 'carregando',
            id: self.cpntField[keyFiltroData].id,
            field: {},
            ref: keyFiltroData
          }

          self.filtroExtras.field = {
            dataTipo: {
              tipo: 'select2',
              status: '',
              id: self.filtroExtras.id + '-dataTipo',
              nome: !self.cpntField[keyFiltroData].hasOwnProperty('nome') || self.cpntField[keyFiltroData].nome === '' ? 'Período' : self.cpntField[keyFiltroData].nome,
              keyValue: 'id',
              keyMostra: [ 'nome' ],
              optionInicialNome: 'Todos',
              value: self.cpntField[keyFiltroData].value,
              options: [
                { id: '1', nome: 'Hoje (' + self.$store.state.dadosApi.dataAtual + ')' },
                { id: '2', nome: 'Mês atual' },
                { id: '3', nome: 'Mês anterior' },
                { id: '4', nome: 'Próximo mês' },
                { id: '5', nome: 'Ano atual' },
                { id: '6', nome: 'Ano anterior' },
                { id: '7', nome: 'Personalizado' }
              ],
              onChange: function (value, id) {
                self.onChangeValue(value, id)
              }
            },
            dataIni: {
              tipo: 'input-calendario',
              id: self.filtroExtras.id + '-dataIni',
              mostrar: true,
              nome: 'De',
              value: self.cpntField[keyFiltroData].dataIni !== '' ? moment(self.cpntField[keyFiltroData].dataIni, 'DD/MM/YYYY').format('DD/MM/YYYY') : '',
              onChange: self.onChangeValue
            },
            dataFim: {
              tipo: 'input-calendario',
              id: self.filtroExtras.id + '-dataFim',
              mostrar: true,
              nome: 'Até',
              value: self.cpntField[keyFiltroData].dataFim !== '' ? moment(self.cpntField[keyFiltroData].dataFim, 'DD/MM/YYYY').format('DD/MM/YYYY') : '',
              onChange: self.onChangeValue
            }
          }

          // CRIA AS CHAVES PADROES DE TODOS OS COMPONENTS
          self.$store.state.FUN_CREATE_KEY_FIELDS(self.filtroExtras.field, function (fields) {
            // SETA OS CAMPOS RECEBIDOS
            self.filtroExtras.field = fields

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            setTimeout(function () {
              // CHAMA A FUNÇÃO PARA FORMATAR O INPUT
              self.formatarDataBusca()

              // SETA O STATUS DOS FILTROS
              self.filtroExtras.status = ''

              // CHAMA A FUNÇÃO PARA FINALIZAR O FORMULARIO
              self.finalizarFiltrosBusca()
            }, 200)
          })
        } else {
          // CHAMA A FUNÇÃO PARA FINALIZAR O FORMULARIO
          self.finalizarFiltrosBusca()
        }
      },
      filtroSetarDataAtualizada: function () {
        var moment = require('moment')

        // SETA O VALOR NOVO RECEBIDO
        this.filtroExtras.field.dataTipo.value = this.cpntField[this.filtroExtras.ref].value

        if (this.cpntField[this.filtroExtras.ref].value !== '7') {
          // CHAMA A FUNÇÃO PARA FORMATAR O INPUT
          this.formatarDataBusca()
        } else {
          this.filtroExtras.field.dataIni.value = (this.cpntField[this.filtroExtras.ref].dataIni !== '' ? moment(this.cpntField[this.filtroExtras.ref].dataIni, 'DD/MM/YYYY').format('DD/MM/YYYY') : '')

          this.filtroExtras.field.dataFim.value = (this.cpntField[this.filtroExtras.ref].dataFim !== '' ? moment(this.cpntField[this.filtroExtras.ref].dataFim, 'DD/MM/YYYY').format('DD/MM/YYYY') : '')
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      finalizarFiltrosBusca: function () {
        // SETA O STATUS DA TELA
        this.status = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // CHAMA A FUNÇÃO PARA DAR FOCUS NO CAMPO
        // this.realizarFocusNoCampo('input-busca')
      },
      onChangeValue: function (value, id) {
        // PEGA O NOME DO CAMPO QUE ESTA SENDO ALTERADO
        var index = id.substring((this.filtroExtras.id.length + 1), id.length)

        // SETA O VALOR RECEBIDO
        this.filtroExtras.field[index].value = value

        // REMOVE A MENSAGEM DE ERRO
        this.filtroExtras.field[index].mensagem = ''
        this.filtroExtras.field[index].mensagemTipo = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        switch (index) {
          case 'dataTipo':
            this.formatarDataBusca()
            break

          case 'dataIni':
          case 'dataFim':
            // CHAMA A FUNÇÃO PARA ATUALIZAR OS VALORES NA PESQUISA
            this.cpntField[this.filtroExtras.ref].onChange(this.filtroExtras.field.dataIni.value, this.filtroExtras.field.dataFim.value)
            break
        }
      },
      formatarDataBusca: function () {
        var moment = require('moment')

        var dataIni = ''
        var dataFim = ''

        switch (this.filtroExtras.field.dataTipo.value) {
          case '':
            // SETA A DATA INICIAL
            dataIni = ''

            // SETA A DATA FINAL
            dataFim = ''
            break

          case '1':
            // SETA A DATA INICIAL
            dataIni = this.$store.state.dadosApi.dataAtual

            // SETA A DATA FINAL
            dataFim = this.$store.state.dadosApi.dataAtual
            break

          case '3':
            // SETA A DATA INICIAL
            dataIni = moment(this.$store.state.dadosApi.dataAtual, 'DD/MM/YYYY').subtract(1, 'M').startOf('M').format('DD/MM/YYYY')

            // SETA A DATA FINAL
            dataFim = moment(this.$store.state.dadosApi.dataAtual, 'DD/MM/YYYY').subtract(1, 'M').endOf('M').format('DD/MM/YYYY')
            break

          case '4':
            // SETA A DATA INICIAL
            dataIni = moment(this.$store.state.dadosApi.dataAtual, 'DD/MM/YYYY').add(1, 'M').startOf('M').format('DD/MM/YYYY')

            // SETA A DATA FINAL
            dataFim = moment(this.$store.state.dadosApi.dataAtual, 'DD/MM/YYYY').add(1, 'M').endOf('M').format('DD/MM/YYYY')
            break

          case '5':
            // SETA A DATA INICIAL
            dataIni = moment(this.$store.state.dadosApi.dataAtual, 'DD/MM/YYYY').startOf('Y').format('DD/MM/YYYY')

            // SETA A DATA FINAL
            dataFim = moment(this.$store.state.dadosApi.dataAtual, 'DD/MM/YYYY').endOf('Y').format('DD/MM/YYYY')
            break

          case '6':
            // SETA A DATA INICIAL
            dataIni = moment(this.$store.state.dadosApi.dataAtual, 'DD/MM/YYYY').subtract(1, 'Y').startOf('Y').format('DD/MM/YYYY')

            // SETA A DATA FINAL
            dataFim = moment(this.$store.state.dadosApi.dataAtual, 'DD/MM/YYYY').subtract(1, 'Y').endOf('Y').format('DD/MM/YYYY')
            break

          case '2':
          case '7':
            // SETA A DATA INICIAL
            dataIni = moment(this.$store.state.dadosApi.dataAtual, 'DD/MM/YYYY').startOf('M').format('DD/MM/YYYY')

            // SETA A DATA FINAL
            dataFim = moment(this.$store.state.dadosApi.dataAtual, 'DD/MM/YYYY').endOf('M').format('DD/MM/YYYY')
            break
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // VERIFICA SE TEM QUE CHAMAR A FUNÇÃO PARA ATUALIZAR FILTRO
        if (dataIni !== this.cpntField[this.filtroExtras.ref].dataIni || dataFim !== this.cpntField[this.filtroExtras.ref].dataFim) {
          // SETA DOS DADOS NO CAMPO
          this.filtroExtras.field.dataIni.value = dataIni
          this.filtroExtras.field.dataFim.value = dataFim

          this.cpntField[this.filtroExtras.ref].onChange(dataIni, dataFim)
        }
      },
      realizarFocusNoCampo: function (field, tentativa = 0) {
        var self = this

        setTimeout(function () {
          if (self.$refs.hasOwnProperty(field)) {
            // SETA O FOCUS NO CAMPO
            self.$refs[field][0].select()

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
          } else if (tentativa <= 10) {
            self.realizarFocusNoCampo(field, (tentativa + 1))
          }
        }, 50)
      },
      filtrosRealizarBusca: function () {
        this.cpntOnRealizaBusca()
      }
    },
    watch: {
      cpntField: function () {
        this.filtrosIniciar()
      },
      // SETA A NOVA TIME PARA FORÇAR A ATUALIZAÇÃO DOS COMPONENTS
      'cpntTime': function () {
        this.time = new Date().getTime()
      }
    }
  }
</script>
